import { WebPriceCalculator, SelectionItem, WebLocation } from "../models/";
import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { CustomerService } from "./customer.service";
import { LocationClient } from "../models/";
import { CompanyService } from "./company.service";
import { AuthService } from "./auth.service";
import { filter } from "rxjs/operators";


@Injectable({
    providedIn: "root"
})
export class LocationListService
{

    private branchCustId: string;
    private billingAddress: string;

    public locationPriceVisible: boolean;

    private locationDescriptionMap = new Map();
    private locationAddresses = new Map();

    private locationDescriptionsSubject = new BehaviorSubject<SelectionItem[]>([]);
    public locationDescriptions: Observable<SelectionItem[]> = this.locationDescriptionsSubject.asObservable();

    private locationListSubject = new BehaviorSubject<WebLocation[]>([]);
    public locationList: Observable<WebLocation[]> = this.locationListSubject.asObservable();

    private locationSubject = new BehaviorSubject<WebLocation>(null);
    public location: Observable<WebLocation> = this.locationSubject.asObservable();

    isEmployee: boolean = false;
    constructor(
        private locationClient: LocationClient,
        private customerService: CustomerService,
        public companyService: CompanyService,
        private authService: AuthService,
    )
    {
        this.customerService.customer
            .pipe(filter(customer => !!customer))
            .subscribe(customer =>
            {
                this.branchCustId = customer.BranchCustId;
                this.billingAddress = customer.Addr1 + " " + customer.City + ", " + customer.State + " " + customer.Zip
                this.getLocationList();
                this.getFullDescriptions();
            });
        this.companyService.webSettings.subscribe(w =>
        {
            if
                (w !== null)
            { this.locationPriceVisible = w.IsLocationPriceEnabledWeb ?? false }

        });
        this.authService.currentUserInfo.subscribe(c =>
        {
            this.isEmployee = c.isCompany;
        });
    }

    private getLocationList()
    {
        this.locationClient.getWebLocationListItemsByCustId(this.branchCustId)
            .subscribe(l =>
            {
                l.forEach(m =>
                {
                    this.locationDescriptionMap.set(m.Loc, m.LocUsageDesc);
                    l.forEach(m =>
                    {
                        this.locationAddresses.set(m.FullAddress, m.LocationTypeDescription);
                        if (!m.FullAddress) { m.FullAddress = this.billingAddress }
                    })
                });
                this.locationListSubject.next(l);
            });
    }
    public getFullDescriptions()
    {
        return this.locationClient.getLocationDescriptions().subscribe(d =>
        {
            this.locationDescriptionsSubject.next(d);
        });
    }
    public getLocationDesc(key: number): string
    {
        return this.locationDescriptionMap.has(key) ? this.locationDescriptionMap.get(key) : "N/A";
    }

    public getPriceCalculatorItems(webPriceCalcItems: WebPriceCalculator)
    {
        return this.locationClient.calculatePrices(webPriceCalcItems);
    }

    // Used for FDS versions older than 10.02.08xx. This will get an estimated percent for levels in tanks etc.
    public getLocationByIdWeb(loc: number)
    {
        return this.locationClient.getLocationByIdWeb(this.branchCustId, loc);
    }
}
